import { getSuspensions } from "../services/contractService";
import { useQuery } from "@tanstack/react-query";

const useSuspensions = (contractId) => useQuery({
    queryKey: ['suspensions', contractId],
    queryFn: () => getSuspensions(contractId, 1).then(res => res.data),
    staleTime: 24 * 60 * 60 * 100 // 24hrs
});

export default useSuspensions;